export default __webpack_public_path__ + "static/media/redes.f8552894.png";